<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header">
                    <h3 class="fw-bold mb-3">Relatórios</h3>
                    <ul class="breadcrumbs mb-3">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Relatórios Evolução da Carteira</a>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-4 col-lg-4" v-if="User.garid == 0">
                                        <div class="form-group">
                                            <label>Garantidora</label>
                                            <select v-model="GarantidoraSelected" class="form-select form-control"
                                                @change="BuscaImobiliarias()">
                                                <option :value=null>Selecione</option>
                                                <option v-for="optionTipo in Garantidoras" :key="optionTipo.garId"
                                                    :value="optionTipo.garId">{{ optionTipo.garNomeEmpresa }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="User.garid == 0 || User.tpeid == 1">
                                        <div class="form-group">
                                            <label>Imobiliaria</label>
                                            <select v-model="ImobiliariaSelected" class="form-select form-control">
                                                <option :value=null>Selecione</option>
                                                <option v-for="optionTipo in Imobiliarias" :key="optionTipo.imoId"
                                                    :value="optionTipo.imoId">{{ optionTipo.imoNomeEmpresa }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Tipo</label>
                                            <select v-model="TipoSelected" class="form-select form-control">
                                                <option :value=null>Selecione</option>
                                                <option v-for="(optionTipo, index) in Tipos" :key="index"
                                                    :value="optionTipo.valor">{{ optionTipo.texto }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Data Inicial</label>
                                            <input v-model="DataIncial" type="date" class="form-control"
                                                placeholder="Data Inicial" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Data Final</label>
                                            <input v-model="DataFinal" type="date" class="form-control"
                                                placeholder="Data Final" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <button type="button" class="btn btn-info"
                                            style="color:#ffffff;margin-top: 35px;" @click="Pesquisar()">
                                            Pesquisar
                                        </button>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <a href="#" @click="EditCancel()" class="btn btn-link"
                                            style="margin-top: 35px;">Cancelar</a>
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px;padding-bottom: 20px;">
                                    <hr>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="d-flex align-items-center">
                                            <h4 class="card-title">Resultado</h4>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" md="6" style="padding-bottom: 30px;">
                                                <v-text-field v-model="searchValue" label="Pesquisa"
                                                    variant="underlined" required></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6" style="text-align: right;padding-right: 15px;">
                                                <button @click="exportCSV" class="btn-sm btn-warning">Exportar CSV</button>
                                            </v-col>
                                        </v-row>
                                        <easy-data-table :headers="headers" :items="ListResult" v-model="itemsSelected"
                                            alternating theme-color="#364f66" table-class-name="customize-table"
                                            header-text-direction="center" body-text-direction="center"
                                            rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                                            <template #item-mes="item">
                                                <span> {{ item.mes !== null ?
                                                    $moment(item.mes).format('MM/YYYY') : null }}</span>
                                            </template>
                                            <template #item-quantidade="item">
                                                <span> {{ item.quantidade !== null ?
                                                    TipoSelected == 'Receita' ?formatarValor(item.quantidade): item.quantidade : null }}</span>
                                            </template>
                                        </easy-data-table>
                                    </div>
                                    <div class="col-md-8">
                                        <div v-if="ListResult && ListResult.length > 0">
                                            <BarChart :datacollection="datacollection" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'
import BarChart from '../../components/PageBarChart.vue'

export default {
    name: 'RelatorioEvolucaoCarteiraView',
    components: {
        EasyDataTable,
        moment,
        BarChart
    },
    data: () => ({
          User: {
            garid:0,
            tpeid:0,
            pesid:0,
        },
        editor: DecoupledEditor,
        GarantidorasGeral: [],
        Garantidoras: [],
        GarantidoraSelected: null,
        ImobiliariasGeral: [],
        Imobiliarias: [],
        ImobiliariaSelected: null,
        ClientesGeral: [],
        Clientes: [],
        ClienteSelected: null,
        DataIncial: '',
        DataFinal: '',
        searchValue: '',
        itemsSelected: [],
        ListResult: [],
        ListPedidosGeral: [],
        ListPedidosGeralFiltro: [],
        ListaPedidoItem: [],
        headers: [],
        TipoSelected: null,
        Tipos: [{ texto: 'Clientes', valor: 'Clientes' }, { texto: 'Contratos', valor: 'Contratos' }, { texto: 'Receita', valor: 'Receita' }],
        datacollection: {
            labels: [],
            datasets: [{
                data: [],
                backgroundColor: [
                    '#302340'
                ]
            }]
        },
    }),
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        EditGrid(item) {

        },
        EditCancel() {
            this.$router.go(0);
        },
        GarantidoraEdit(Value) {
            this.Garantidoras = this.GarantidorasGeral.filter(x => x.garId == Value);
            this.GarantidoraSelected = Value;
            this.BuscaImobiliarias();
        },
        BuscaImobiliarias() {
            if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
                this.ImobiliariaSelected = null;
                this.ImobiliariasGeral = [];
                this.Imobiliarias = [];
                axios.get(`/Telas/RelatorioEvolucaoCarteira/GetByGarIdParIdImobiliarias/` + this.GarantidoraSelected + '/0')
                    .then(response => {
                        if (response.data.length > 0) {
                            this.ImobiliariasGeral = response.data.filter(x => x.imoAtivo).sort((a, b) =>
                        a.imoNomeEmpresa.localeCompare(
                        b.imoNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                            this.Imobiliarias = this.ImobiliariasGeral;
                        }
                    });
            }
            else {
                this.ImobiliariaSelected = null;
                this.ImobiliariasGeral = [];
                this.Imobiliarias = [];
                this.ClienteSelected = null;
                this.ClientesGeral = [];
                this.Clientes = [];
            }
        },
        montaGrid() {
            this.headers = [];
            this.headers.push({ text: "Mês", value: "mes", sortable: true, });
            if (this.TipoSelected === 'Receita') {
             this.headers.push({ text: "Valor", value: "quantidade", sortable: true, });
            } else{
                this.headers.push({ text: "Quantidade", value: "quantidade", sortable: true, });
            }

        },
        updateChartData(newLabels, newValues) {
            this.datacollection = {
                labels: newLabels,
                datasets: [{
                    data: newValues,
                    backgroundColor: [
                    '#302340'
                    ]
                }]
            }
        },
        montarGrafico() {
            const newLabels = this.ListResult.map(item => item.mes);
            const newValues = this.ListResult.map(item => item.quantidade);
            this.updateChartData(newLabels, newValues);
            //console.log('this.datacollection')
            //console.log(this.datacollection)
        },
        async Pesquisar() {
            // Validação: DataFinal não pode ser menor que DataIncial
            if (moment(this.DataFinal).isBefore(moment(this.DataIncial))) {
                this.$mensagemAviso("Data Final não pode ser menor que Data Inicial!");
                return;
            }
            if (this.TipoSelected == null || this.TipoSelected == '') {
                this.$mensagemAviso("Selecione o Tipo de Evolução!");
                return;
            }

            // Define os parâmetros para a consulta
            const _garId = this.GarantidoraSelected || 0;
            const _tpeid = this.ImobiliariaSelected ? 3 : 0;
            const _pesid = this.ImobiliariaSelected || 0;

            try {
                // Consulta os pedidos
                const response = await axios.get(
                    `/Telas/RelatorioEvolucaoCarteira/GetAllValorTotal/${_garId}/${_tpeid}/${_pesid}`
                );

                if (this.TipoSelected === 'Clientes') {
                    // Filtra para pegar somente os pedidos com situação "Vigente"
                    this.ListPedidosGeral = response.data;
                }
                if (this.TipoSelected === 'Contratos') {
                     // Filtra para pegar somente os pedidos com situação "Vigente"
                    this.ListPedidosGeral = response.data.filter(
                        (x) => x.pspId != 4 && x.pspId != 6
                    );
                }
                if (this.TipoSelected === 'Receita') {
                      // Filtra para pegar somente os pedidos com situação "Vigente"
                    this.ListPedidosGeral = response.data.filter(
                        (x) => x.pspId == 3
                    );
                }         

                // Mapeia os pedidos para incluir informações adicionais
                this.ListPedidosGeralFiltro = this.ListPedidosGeral.map((pedido) => {
                    // Busca a garantidora correspondente pelo garId
                    const garantidora = this.GarantidorasGeral.find((g) => g.garId === pedido.garId);
                    // Busca a imobiliária correspondente pelo imobId
                    const imobiliaria = this.ImobiliariasGeral.find((i) => i.imoId === pedido.imobId);

                    return {
                        ...pedido,
                        NomeGarantidora: garantidora ? garantidora.garNomeEmpresa : "Não encontrada",
                        DocumentoImobiliaria: imobiliaria ? imobiliaria.imoDocumento : "Não encontrada",
                    };
                });

                // Inicia o filtro com a lista completa
                let filtered = [...this.ListPedidosGeralFiltro];
               // console.log(filtered)

                // Aplica o filtro por data (usando pedDataPedido) se ambos os campos estiverem preenchidos
                if (this.DataFinal !== "" && this.DataIncial !== "") {
                    // Converte os filtros para objetos Date
                    const dataInicio = new Date(this.DataIncial);
                    const dataFinal = new Date(this.DataFinal);
                    // Ajusta o final do dia para incluir todo o dia
                    dataFinal.setHours(23, 59, 59, 999);

                    filtered = filtered.filter((x) => {
                        // Se a data do pedido estiver ausente, ignora o registro
                        if (!x.pedDataPedido) {
                            console.error("Data inválida para o registro:", x);
                            return false;
                        }
                        const dataRegistro = new Date(x.pedDataPedido);
                        if (isNaN(dataRegistro.getTime())) {
                            console.error("Data inválida para o registro:", x.pedDataPedido);
                            return false;
                        }
                        return dataRegistro >= dataInicio && dataRegistro <= dataFinal;
                    });
                }

                // Após todos os filtros terem sido aplicados na variável "filtered"
                if (this.TipoSelected === 'Clientes') {
                // Agrupar por mês usando pedDataPedido e contar os cliIds distintos em cada mês
                const agrupado = filtered.reduce((acc, item) => {
                    if (!item.pedDataPedido) return acc; // ignora registros sem data

                    // Converte a data e extrai o ano e o mês (ex: "2025-01")
                    const date = new Date(item.pedDataPedido);
                    const monthKey = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}`;
                    console.log('date')
                    console.log(date)
                    if (!acc[monthKey]) {
                    acc[monthKey] = { mes: monthKey, cliIds: new Set() };
                    }
                    // Adiciona o cliId ao conjunto, se existir
                    if (item.cliId) {
                    acc[monthKey].cliIds.add(item.cliId);
                    }
                    return acc;
                }, {});

                // Transforma o objeto em array, contando a quantidade de cliIds distintos em cada mês
                this.ListResult = Object.values(agrupado).map(group => ({
                    mes: group.mes,
                    quantidade: group.cliIds.size
                }));
                } else if (this.TipoSelected === 'Contratos') {
                // Agrupar por mês usando pedDataPedido e contar os pedIds únicos em cada mês
                const agrupado = filtered.reduce((acc, item) => {
                    if (!item.pedDataPedido) return acc; // ignora registros sem data
                    const date = new Date(item.pedDataPedido);
                    // Cria a chave no formato "YYYY-MM"
                    const monthKey = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}`;
                    if (!acc[monthKey]) {
                    acc[monthKey] = { mes: monthKey, pedIds: new Set() };
                    }
                    if (item.pedId) {
                    acc[monthKey].pedIds.add(item.pedId);
                    }
                    return acc;
                }, {});

                // Transforma o objeto em array, contando a quantidade de contratos distintos em cada mês
                this.ListResult = Object.values(agrupado).map(group => ({
                    mes: group.mes,
                    quantidade: group.pedIds.size
                }));
                }
                else if (this.TipoSelected === 'Receita') {
                // Agrupar por mês usando pedDataPedido e somar pedValorFinalPago em cada mês
                const agrupado = filtered.reduce((acc, item) => {
                    // Se a data do pedido estiver ausente, ignora o registro
                    if (!item.pedDataPedido) return acc;
                    const date = new Date(item.pedDataPedido);
                    // Cria a chave no formato "YYYY-MM"
                    const monthKey = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}`;
                    if (!acc[monthKey]) {
                    acc[monthKey] = { mes: monthKey, receita: 0 };
                    }
                    // Acumula o valor da receita; converte para número caso necessário
                    acc[monthKey].receita += Number(item.pedValorFinalPago) || 0;
                    return acc;
                }, {});

                // Transforma o objeto agrupado em array
                this.ListResult = Object.values(agrupado).map(group => ({
                    mes: group.mes,
                    quantidade: group.receita
                }));
                } 

                this.montaGrid();
                this.montarGrafico();


                //console.log("this.ListResult1", this.ListResult);
            } catch (error) {
                console.error(error);
            }
        },
        exportCSV() {
            if (this.ListResult.length === 0) {
                alert("Não há dados para exportar.");
                return;
            }

            let _Garantidora = "Todas";
            let _Imobliaria = "Todas";

            if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
                _Garantidora = this.GarantidorasGeral.filter(x => x.garId == this.GarantidoraSelected)[0].garNomeEmpresa;
            }

            if (this.ImobiliariaSelected != '' && this.ImobiliariaSelected != null) {
                _Imobliaria = this.ImobiliariasGeral.filter(x => x.imoId == this.ImobiliariaSelected)[0].imoNomeEmpresa;
            }
            // Cria as linhas de filtros (ajuste os nomes dos filtros conforme necessário)
            const filtroCSV =
                `Garantidora: ${_Garantidora}\n` +
                `Imobiliária: ${_Imobliaria}\n` +
                `Data Inicial: ${this.DataIncial}\n` +
                `Data Final: ${this.DataFinal}\n` +
                `Tipo de Evolução: ${this.TipoSelected}\n\n`;

            // Cria o cabeçalho do CSV (os nomes das colunas)
            const csvHeader = this.headers.map(h => h.text).join(";") + "\n";

            // Cria as linhas com os dados do grid
            const csvRows = this.ListResult.map(item =>
                [
                    item.mes,
                    item.quantidade
                ].join(";")
            ).join("\n");

            // Concatena os filtros, o cabeçalho e as linhas de dados
            const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + filtroCSV + csvHeader + csvRows;

            // Cria o link de download
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "RelatorioEvolucaoCarteira.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async Get() {
            await axios.get(`/Telas/RelatorioEvolucaoCarteira/GetDados`)
                .then(response => {
                    this.GarantidorasGeral = response.data.garGarantidoras.filter(x => x.garAtivo).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                            b.garNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );
                    this.User.tpeid = response.data.tpeId
                    this.User.garid = response.data.garId
                    this.User.pesid = response.data.pesId


                    this.ImobiliariasGeral = response.data.imobiliarias.filter(x => x.imoAtivo).sort((a, b) =>
                        a.imoNomeEmpresa.localeCompare(
                            b.imoNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );

                    if (this.User.garid == 0) {
                        this.EditView = false;
                        this.Garantidoras = this.GarantidorasGeral;
                    }
                    else {
                        this.GarantidoraEdit(this.User.garid);
                    }
                });         
        }
    },
    created() {
        this.Get();
    },
    watch: {
        ListResult(newVal) {
            const newLabels = newVal.map(item => item.mes);
            const newValues = newVal.map(item => item.quantidade);
            this.updateChartData(newLabels, newValues);
        }
    }
}
</script>

<style></style>
